import React, { useEffect, useState } from "react"
import { Backdrop, Box, CircularProgress } from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { defineMessages } from "react-intl"
import { useQuery } from "../../commons/utils"
import httpClient from "../../api/httpClient"
import useSmartFormat from "../../i18n/useSmartFormat"
import { words } from "../../i18n/lstrings"

const messages = defineMessages({
  successTitle: {
    id: "mailPreferences.unsubscribeSuccess.title",
    defaultMessage: "You have successfully unsubscribed."
  },
  successDescription: {
    id: "mailPreferences.unsubscribeSuccess.description",
    defaultMessage:
      "You can resubscribe or manage your email notification preferences by signing in to the portal."
  }
})

export default function UnsubscriptionConfirmationPage() {
  const query = useQuery()
  const format = useSmartFormat()
  const unsubscribeToken = query.get("unsubscribeToken")
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(undefined)

  useEffect(() => {
    async function unsubscribe() {
      const queryParams = new URLSearchParams({ unsubscribeToken })
      const url = "/api/user/email-unsubscribe".concat(
        "?",
        queryParams.toString()
      )
      try {
        await httpClient.post(url)
      } catch (caughtError) {
        setError(caughtError)
      } finally {
        setIsLoading(false)
      }
    }

    unsubscribe().then()
  }, [unsubscribeToken])

  return (
    <Box
      display="flex"
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
    >
      {isLoading && (
        <Backdrop open={isLoading}>
          <CircularProgress />
        </Backdrop>
      )}

      {!isLoading &&
        (error ? (
          <Alert severity="error">
            <AlertTitle>{format(words.error)}</AlertTitle>
            {format(error.message)}
          </Alert>
        ) : (
          <Alert variant="outlined" severity="success">
            <AlertTitle>{format(messages.successTitle)}</AlertTitle>
            {format(messages.successDescription)}
          </Alert>
        ))}
    </Box>
  )
}
